import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SettingsBaseApi {
  #http = inject(HttpClient);

  settings$() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.#http.get<any>(
      `/api/settings`
    );
  }

}
